import styled, { css } from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export * from './cart-entry.styled.default';

const rowCss = css<{ row?: number }>`
  padding: ${primitive.$spacing6} 0;
  border-bottom: 1px solid ${p => p.theme.token('border-color-default')};
  grid-row: ${({ row = 0 }) => `${row}/${row + 1}`};

  /* remove border for last row in grid */
  &:nth-last-child(-n + 3) {
    border-bottom: none;
  }
`;

export const ItemName = styled.h4<{ row?: number }>`
  ${rowCss}
  font-size: 1rem;
  margin: 0;
  grid-column: 1 / 2;
`;

export const ItemPrice = styled.div<{ row?: number }>`
  ${rowCss}
  text-align: end;
  grid-column: 3 / 4;
`;

export const ItemQuantityBadge = styled.div<{ quantityText?: string; row?: number }>`
  ${rowCss}
  text-align: center;
  grid-column: 2 / 3;
  &:before {
    content: ${({ quantityText = 'Qty: ' }) => quantityText};
  }
`;
